"use strict";

exports.__esModule = true;
exports.getStackStyles = getStackStyles;
exports.getDividerStyles = getDividerStyles;
exports.selector = void 0;

var _utils = require("@chakra-ui/utils");

/**
 * If we ever run into SSR issues with this, check this post to find a fix for it:
 * @see https://medium.com/@emmenko/patching-lobotomized-owl-selector-for-emotion-ssr-5a582a3c424c
 */
var selector = "& > *:not(style) ~ *:not(style)";
exports.selector = selector;

function getStackStyles(options) {
  var _ref;

  var spacing = options.spacing,
      direction = options.direction;
  var directionStyles = {
    column: {
      marginTop: spacing,
      marginStart: 0
    },
    row: {
      marginStart: spacing,
      marginTop: 0
    },
    "column-reverse": {
      marginBottom: spacing,
      marginEnd: 0
    },
    "row-reverse": {
      marginEnd: spacing,
      marginBottom: 0
    }
  };
  return _ref = {
    flexDirection: direction
  }, _ref[selector] = (0, _utils.mapResponsive)(direction, function (value) {
    return directionStyles[value];
  }), _ref;
}

function getDividerStyles(options) {
  var spacing = options.spacing,
      direction = options.direction;
  var dividerStyles = {
    column: {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": (0, _utils.mapResponsive)(direction, function (value) {
      return dividerStyles[value];
    })
  };
}
//# sourceMappingURL=stack.utils.js.map